// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"11b80c86","498":"9eb237e5","703":"c37ca6a5","787":"4ad46790"}[chunkId] + ".chunk.js";
};